var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyPolicyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#212121"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logged In",
    clipPath: "url(#clip0_1102_1882)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    transform: "translate(-24 -435)",
    fill: "#131620"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2087325984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2087325981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input_invite"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1102_1882",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8 0.799999C-8 -3.68042 -8 -5.92063 -7.12805 -7.63192C-6.36107 -9.13722 -5.13722 -10.3611 -3.63192 -11.1281C-1.92063 -12 0.31958 -12 4.8 -12H337.2C341.68 -12 343.921 -12 345.632 -11.1281C347.137 -10.3611 348.361 -9.13722 349.128 -7.63192C350 -5.92063 350 -3.68042 350 0.8V31.2C350 35.6804 350 37.9206 349.128 39.6319C348.361 41.1372 347.137 42.3611 345.632 43.1281C343.921 44 341.68 44 337.2 44H4.79998C0.319574 44 -1.92063 44 -3.63192 43.1281C-5.13722 42.3611 -6.36107 41.1372 -7.12805 39.6319C-8 37.9206 -8 35.6804 -8 31.2V0.799999Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-8 0.799999C-8 -3.68042 -8 -5.92063 -7.12805 -7.63192C-6.36107 -9.13722 -5.13722 -10.3611 -3.63192 -11.1281C-1.92063 -12 0.31958 -12 4.8 -12H337.2C341.68 -12 343.921 -12 345.632 -11.1281C347.137 -10.3611 348.361 -9.13722 349.128 -7.63192C350 -5.92063 350 -3.68042 350 0.8V31.2C350 35.6804 350 37.9206 349.128 39.6319C348.361 41.1372 347.137 42.3611 345.632 43.1281C343.921 44 341.68 44 337.2 44H4.79998C0.319574 44 -1.92063 44 -3.63192 43.1281C-5.13722 42.3611 -6.36107 41.1372 -7.12805 39.6319C-8 37.9206 -8 35.6804 -8 31.2V0.799999Z",
    fill: "#1D1F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 -12H350H-8ZM350 36C350 40.6944 346.194 44.5 341.5 44.5H0.5C-4.19442 44.5 -8 40.6944 -8 36C-8 40.1421 -4.41828 43.5 0 43.5H342C346.418 43.5 350 40.1421 350 36ZM-8 44V-12V44ZM350 -12V44V-12Z",
    fill: "#1D1F2E",
    mask: "url(#path-1-inside-1_1102_1882)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2087325980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 22H14V21.5C14 20.5717 13.6313 19.6815 12.9749 19.0251C12.3185 18.3687 11.4283 18 10.5 18C9.57174 18 8.6815 18.3687 8.02513 19.0251C7.36875 19.6815 7 20.5717 7 21.5V22H6C5.73478 22 5.48043 22.1054 5.29289 22.2929C5.10536 22.4804 5 22.7348 5 23V28C5 28.2652 5.10536 28.5196 5.29289 28.7071C5.48043 28.8946 5.73478 29 6 29H15C15.2652 29 15.5196 28.8946 15.7071 28.7071C15.8946 28.5196 16 28.2652 16 28V23C16 22.7348 15.8946 22.4804 15.7071 22.2929C15.5196 22.1054 15.2652 22 15 22ZM9 21.5C9 21.1022 9.15804 20.7206 9.43934 20.4393C9.72064 20.158 10.1022 20 10.5 20C10.8978 20 11.2794 20.158 11.5607 20.4393C11.842 20.7206 12 21.1022 12 21.5V22H9V21.5ZM14 27H7V24H14V27ZM26.7075 10.2925L19.7075 3.2925C19.6146 3.19967 19.5042 3.12605 19.3829 3.07586C19.2615 3.02568 19.1314 2.9999 19 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V16C5 16.2652 5.10536 16.5196 5.29289 16.7071C5.48043 16.8946 5.73478 17 6 17C6.26522 17 6.51957 16.8946 6.70711 16.7071C6.89464 16.5196 7 16.2652 7 16V5H18V11C18 11.2652 18.1054 11.5196 18.2929 11.7071C18.4804 11.8946 18.7348 12 19 12H25V27H20C19.7348 27 19.4804 27.1054 19.2929 27.2929C19.1054 27.4804 19 27.7348 19 28C19 28.2652 19.1054 28.5196 19.2929 28.7071C19.4804 28.8946 19.7348 29 20 29H25C25.5304 29 26.0391 28.7893 26.4142 28.4142C26.7893 28.0391 27 27.5304 27 27V11C27.0001 10.8686 26.9743 10.7385 26.9241 10.6172C26.8739 10.4958 26.8003 10.3854 26.7075 10.2925ZM20 6.41375L23.5863 10H20V6.41375Z",
    fill: "#B5B5B5"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1102_1882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    fill: "white",
    transform: "translate(-24 -435)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicyIcon);
export default __webpack_public_path__ + "static/media/privacy-policy-icon.a95a90a8afb5c45f15990bbaa0a8c3b0.svg";
export { ForwardRef as ReactComponent };